import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-gray-100 shadow-md sticky top-0 z-50">
      <div className="max-w-8xl mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          {/* Logo + Name */}
          <Link to="/" className="flex items-center space-x-2 md:space-x-4">
            <img
              src="/logo.png"
              alt="Sports Experts Infra Logo"
              className="max-h-12 md:max-h-14 lg:max-h-16 h-auto w-auto object-contain drop-shadow-md shrink-0"
              loading="eager"
              decoding="async"
            />
            <span className="text-xl md:text-2xl lg:text-3xl font-bold text-gray-700 drop-shadow-sm">Sports Experts Infra</span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-6 text-gray-700 font-bold">
            <Link to="/" className="hover:text-orange-500  transition">Home</Link>
            <Link to="/about" className="hover:text-orange-500  transition">About</Link>
            <Link to="/services" className="hover:text-orange-500  transition">Services</Link>
           
            <Link to="/gallery" className="hover:text-orange-500  transition">Gallery</Link>
           
            <Link to="/career" className="hover:text-orange-500  transition">Career</Link>
            <Link to="/contact" className="hover:text-orange-500  transition">Contact</Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-700 focus:outline-none"
            >
              {isOpen ? (
                <XMarkIcon className="w-6 h-6" />
              ) : (
                <Bars3Icon className="w-6 h-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4 text-gray-700 font-medium">
            <Link 
              to="/" 
              onClick={() => setIsOpen(false)}
              className="block hover:text-orange-600 transition"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              onClick={() => setIsOpen(false)}
              className="block hover:text-orange-600 transition"
            >
              About
            </Link>
            <Link 
              to="/services" 
              onClick={() => setIsOpen(false)}
              className="block hover:text-orange-600 transition"
            >
              Services
            </Link>
            <Link 
              to="/projects" 
              onClick={() => setIsOpen(false)}
              className="block hover:text-orange-600 transition"
            >
              Projects
            </Link>
            <Link 
              to="/gallery" 
              onClick={() => setIsOpen(false)}
              className="block hover:text-orange-600 transition"
            >
              Gallery
            </Link>
            <Link 
              to="/clients" 
              onClick={() => setIsOpen(false)}
              className="block hover:text-orange-600 transition"
            >
              Clients
            </Link>
            <Link 
              to="/career" 
              onClick={() => setIsOpen(false)}
              className="block hover:text-orange-600 transition"
            >
              Career
            </Link>
            <Link 
              to="/contact" 
              onClick={() => setIsOpen(false)}
              className="block hover:text-orange-600 transition"
            >
              Contact
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
